import { useAuth } from '../../hooks';

/**
 * Shown by signed-in pages in place of the redirect to sign-in when the session
 * check failed — an API outage must not look like being logged out.
 */
export function SessionUnavailable() {
  const { sessionError, retrySession, loading } = useAuth();

  return (
    <div className="flex-1 bg-base-200 flex items-center justify-center p-6">
      <div role="alert" className="card bg-base-100 p-6 max-w-md text-center">
        <h1 className="text-base-content mb-1">We can't reach mockd right now</h1>
        <p className="text-sm text-base-content/80 mb-4">
          You haven't been signed out. Check your connection and try again.
        </p>
        {sessionError && (
          <p className="text-xs text-error mb-4">{sessionError}</p>
        )}
        <button
          type="button"
          onClick={() => { void retrySession(); }}
          disabled={loading}
          className="btn btn-primary btn-sm self-center"
        >
          {loading ? 'Retrying...' : 'Retry'}
        </button>
      </div>
    </div>
  );
}
